import { api, setToken } from './client';
import type { AuthResponse, Tenant } from './types';

export async function register(payload: {
  company_name: string;
  phone: string;
  password: string;
}): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>('/api/auth/register', payload);
  setToken(data.access_token);
  return data;
}

export async function login(payload: {
  phone: string;
  password: string;
}): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>('/api/auth/login', payload);
  setToken(data.access_token);
  return data;
}

export async function getMe(): Promise<Tenant> {
  const { data } = await api.get<Tenant>('/api/auth/me');
  return data;
}

export function logout() {
  setToken(null);
}
